<div
  fxLayout="column"
  class="height-100">
 
  <!-- Toolbar -->
  <div>
    <mat-toolbar fxLayout="row">
      <!-- Close -->
      <span fxFlex fxLayoutAlign="start center">
        <button mat-icon-button [matTooltip]="'LABEL_CLOSE' | translate" (click)="close()" type="button">
          <mat-icon *ngIf="!media.isActive('lt-sm')" svgIcon="close"></mat-icon>
          <mat-icon *ngIf="media.isActive('lt-sm')" svgIcon="arrow-left"></mat-icon>
        </button>
      </span>
 
      <!-- Detail Title -->
      <span 
        fxLayout="row" 
        fxLayoutAlign="center center"
        [class.compact-header-text]="media.isActive('lt-sm')"
        fxFlex="noshrink">        
        {{ 'LABEL_DETAIL' | translate: {type: type} }}
      </span>    
      
      <!-- Edit -->
      <span fxFlex fxLayoutAlign="end center">
        <!-- <button mat-icon-button (click)="modify()" [matTooltip]="'LABEL_EDIT' | translate">
          <mat-icon svgIcon="pencil"></mat-icon>
        </button> -->
      </span>
    </mat-toolbar>
  </div>
 
  <div class="width-100 overflow-auto" fxFlex>
    <mat-tab-group dynamicHeight="false" class="mat-tab-group-md-width" (selectedTabChange)="tabChanged($event)" [(selectedIndex)]="selectedTabIndex">
      <!-- Detail Data -->
      <mat-tab>
        <ng-template mat-tab-label>
          <span>Details</span>
        </ng-template>
        
        <mat-list>
          <mat-list-item 
            *ngFor="let key of detailKeys">
            <h3 matLine class="list-data">
              <span>
                <!-- {{ detailData[key] }} -->
                {{ helper.displayFields(detailData, key) | translate }}
              </span>
            </h3>
            <p matLine class="list-label">
              {{ ('LABEL_' + key | uppercase) | translate }}
            </p>
          </mat-list-item>
        </mat-list>
      </mat-tab>

      <!-- Web User -->
      <mat-tab [disabled]="detailData.role && detailData.role != 'user'">
        <ng-template mat-tab-label>
          <span>Web Users</span>
        </ng-template>
        
        <mat-list class="width-100" *ngIf="!loading.webUsers && webUsers?.length">
          <mat-list-item
            *ngFor="let data of webUsers">
            <h3 matLine class="list-data">
              <span>
                {{ data.username }} - {{ data.fullname }}
              </span>
            </h3>

            <span>
              <button mat-icon-button [matTooltip]="'LABEL_EDIT' | translate" (click)="upsertUserRecipient(data)" *ngIf="authService.hasPermission(moduleCode + constants.PERMISSION_STRINGS.update)">
                <mat-icon svgIcon="pencil"></mat-icon>
              </button>
            </span>
          </mat-list-item>
        </mat-list>

        <!-- Display if no data fetched -->
        <div 
          fxFlex
          fxLayout="column"
          fxLayoutAlign="center center"
          class="height-70vh"
          *ngIf="!loading.error && !loading.webUsers && !webUsers?.length">
    
          <mat-icon color="primary" svgIcon="information-outline" class="size-48"></mat-icon>
    
          <span class="mat-body">
            {{ 'LABEL_NO_DATA' | translate}}
          </span>
        </div>
      </mat-tab>

      <!-- Recipient -->
      <mat-tab [disabled]="detailData.role && detailData.role != 'recipient'">
        <ng-template mat-tab-label>
          <span>Recipient</span>
        </ng-template>
        
        <mat-list class="width-100" *ngIf="!loading.recipients && recipients?.length">
          <mat-list-item 
            *ngFor="let data of recipients">
            <h3 matLine class="list-data">
              <span>
                {{ data.reference_code }} - {{ data.fullname }}
              </span>
            </h3>

            <span>
              <button mat-icon-button [matTooltip]="'LABEL_EDIT' | translate" (click)="upsertUserRecipient(data)" *ngIf="authService.hasPermission(moduleCode + constants.PERMISSION_STRINGS.update)">
                <mat-icon svgIcon="pencil"></mat-icon>
              </button>
            </span>
          </mat-list-item>
        </mat-list>
        
        <!-- Display if no data fetched -->
        <div 
          fxFlex
          fxLayout="column"
          fxLayoutAlign="center center"
          class="height-70vh"
          *ngIf="!loading.error && !loading.recipients && !recipients?.length">

          <mat-icon color="primary" svgIcon="information-outline" class="size-48"></mat-icon>

          <span class="mat-body">
            {{ 'LABEL_NO_DATA' | translate}}
          </span>
        </div>
      </mat-tab>
    </mat-tab-group>

    <button mat-mini-fab color="primary" class="mini-fab-button" (click)="updateGroup()" *ngIf="authService.hasPermission(moduleCode + constants.PERMISSION_STRINGS.update) && selectedTabIndex == 0">
      <mat-icon svgIcon="pencil" [matTooltip]="'LABEL_EDIT_TYPE' | translate : {type: 'LABEL_GROUP' | translate}"></mat-icon>
    </button>

    <button mat-mini-fab color="primary" class="mini-fab-button" (click)="upsertUserRecipient({})" *ngIf="authService.hasPermission(moduleCode + constants.PERMISSION_STRINGS.add) && selectedTabIndex != 0">
      <mat-icon svgIcon="plus" [matTooltip]="'LABEL_ADD_NEW' | translate : {type: (selectedTabIndex == 1 ? ('LABEL_WEB_USER' | translate) : ('LABEL_RECIPIENT' | translate))}"></mat-icon>
    </button>
  </div>
</div>

